import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { MsalProvider } from "@azure/msal-react";
import BaseTeliumSetup from "tealium/BaseTeliumSetup";
import { PublicClientApplication } from "@azure/msal-browser";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { getAppEnv } from "env/env";
import InternalAuthProvider from "auth/internal/InternalAuthProvider";
import ExternalAuthProvider from "auth/external/ExternalAuthProvider";
import { internalConfiguration } from "auth/internal/internalAuthConfig";
import { externalConfiguration } from "auth/external/externalAuthConfig";

import SearchPage from "components/SearchPage/SearchPage";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import ClassDetailPage from "components/ClassDetailPage/ClassDetailPage";
import {
  somethingWentWrong,
  somethingWentWrongDescription,
  closeAndReturnToIcon,
  returnToSearch,
} from "shared/messages";
import "./App.scss";
import UWQuestionsPage from "components/ClassDetailPage/AppetiteGuide/UWQuestions/UWQuestionsPage";
import Layout from "components/Layout/Layout";
import { axiosPostCIAMInstance } from "shared/axiosInstance";
const ipca = new PublicClientApplication(internalConfiguration);
const epca = new PublicClientApplication(externalConfiguration);

const previousPage = localStorage.getItem("previousPage");

const router = createBrowserRouter([
  /* {
    path: "/",
    element: <SearchPage />,
  },
  {
    path: "/classDataSearch",
    element: <ClassDetailPage />,
  },
  {
    path: "/uw-questions",
    element: <UWQuestionsPage />,
  },
  {
    path: "*",
    element: (
      <ErrorMessage
        linkAddress={previousPage?.includes("esubmissions") ? null : "/"}
        showLink={true}
        utilizeNavLink={true}
        linkText={
          previousPage?.includes("esubmissions")
            ? closeAndReturnToIcon
            : returnToSearch
        }
        error={somethingWentWrong}
        icon="icon icon-alert-warning"
        message={somethingWentWrongDescription}
      />
    ),
  }, */
  
{
  path: "/",
  element: <Layout />,
  children: [
    {
      index: true,
      element: <SearchPage />,
    },
    {
      path: "classDataSearch",
      element: <ClassDetailPage />,
    },
    {
      path: "*",
      element: (
      <ErrorMessage 
        linkAddress={previousPage?.includes("esubmissions") ? null : "/"}
        showLink={true}
        utilizeNavLink={true}
        linkText={
          previousPage?.includes("esubmissions")
            ? closeAndReturnToIcon
            : returnToSearch
        }
        error={somethingWentWrong}
        icon="icon icon-alert-warning"
        message={somethingWentWrongDescription}
      />
      ),
    },
  ],
},
{
  path: "/uw-questions",
  element: <UWQuestionsPage />, // no layout here
},
]);

const App = () => {
  const [cookies, setCookies] = useCookies(["CIAMSession", "hartfordEmployee"]);
  const url = window?.location?.href;
  // add  || url.includes("localhost") to isIntranetUrl below to force local development to internal user
  const isIntranetUrl = url.includes("intranet.appetite.thehartford.com");
  BaseTeliumSetup();

  // used for mocking external user with CIAMSession in local
  useEffect(() => {
    let userType = "external";
    if (isIntranetUrl) {
      userType = "internal";
    }
    sessionStorage.setItem("userType", userType);
    //To get the title dynamically
    if (userType === "internal") {
      document.title = "Class Guide Search";
    } else {
      document.title = "Sales Guide Search";
    }
    if (window.location.origin.includes("localhost")) {
      // CIAMSession value should be obtained from EBC login and pasted here to authenticate as external user
      // comment out entire setCookies call to authenticate as internal user
      // setCookies(
      //   "CIAMSession",
      //   "6FZhu7xklcOuU2IZ4Ueo-qFblzQ.*AAJTSQACMDIAAlNLABxwUm1ZWFNib3lmN1ZwMzFLbkVWS05qUDR4K2c9AAR0eXBlAANDVFMAAlMxAAIwMQ..*"
      // );
    }
  }, []);

  const AuthProviderWrapper = ({ children }) => {
    const [ciamValid, setCiamValid] = useState(null);
    const CIAM_URL = getAppEnv().CIAM_URL;
    console.log("CIAM_URL", CIAM_URL);
    useEffect(() => {
      if (!isIntranetUrl) {
        axiosPostCIAMInstance()
          .post(CIAM_URL)
          .then(response => {
            console.log("CIAM response data:", response.data);
            console.log("CIAM response", response);
            if (response.data.username) {
              setCiamValid(true);
            } else {
              setCiamValid(false);
            }
          })
          .catch(error => {
            console.error("CIAM error", error);
            setCiamValid(false);
          });
      }
    }, []);

    if (!isIntranetUrl) {
      if (ciamValid === null) {
        return <div>Loading...</div>;
      }
      if (ciamValid === true) {
        return (
          <MsalProvider instance={epca}>
            <ExternalAuthProvider>{children}</ExternalAuthProvider>
          </MsalProvider>
        );
      }
      // If CIAM session is invalid
      sessionStorage.clear();
      return (
        <ErrorMessage
          showLink={true}
          utilizeNavLink={false}
          icon="icon icon-info"
          linkText="Return to login"
          error="Your session has expired"
          linkAddress={getAppEnv().EBC_DOMAIN}
        />
      );
    }

    if (isIntranetUrl) {
      return (
        <MsalProvider instance={ipca}>
          <InternalAuthProvider>{children}</InternalAuthProvider>
        </MsalProvider>
      );
    }
  };

  return (
    <div
      data-testid="cafe-app"
      className="cafe-app d-flex flex-column justify-content-center"
    >
      <AuthProviderWrapper>
        <RouterProvider router={router} />
      </AuthProviderWrapper>
    </div>
  );
};

export default App;
